import { Box, Image, Text, VStack } from '@chakra-ui/react';
import { Team } from '../HistoryCard.types';
import { LOGO_BOX_STYLES } from '../HistoryCard.styles';

interface TeamDisplayProps {
  team: Team;
  accentColor: string;
}

export const TeamDisplay = ({ team, accentColor }: TeamDisplayProps) => (
  <VStack spacing={{ base: 1.5, md: 2 }} align='center'>
    {team.logo && (
      <Box {...LOGO_BOX_STYLES} borderColor={accentColor}>
        <Image
          src={team.logo}
          alt={team.name}
          boxSize={{ base: '28px', sm: '32px', md: '40px' }}
          borderRadius='full'
          objectFit='cover'
        />
      </Box>
    )}
    <Text
      fontWeight='semibold'
      fontSize='xs'
      noOfLines={2}
      color='dark.D900'
      textAlign='center'
      maxW={{ base: '60px', sm: '80px', md: '100px' }}
      wordBreak='break-word'
    >
      {team.name}
    </Text>
  </VStack>
);
